import * as React from 'react';
import * as styled from './styled';
import {IconSmallClose} from 'icons';
import {OptionProps, OptionVariant} from './types';

/**
 * The option button.
 * @param {OptionProps} props
 * @return {React.ReactElement<OptionProps>}
 * @constructor
 */
function Option(
  {
    onRemove,
    ...otherProps
  }: OptionProps,
): React.ReactElement<OptionProps> {
  /**
   * Render label.
   * @return {JSX.Element}
   */
  function renderLabel(): JSX.Element {
    return (
      <styled.Label>
        {otherProps.children}
      </styled.Label>
    );
  }

  /**
   * Render remove.
   * @return {JSX.Element}
   */
  function renderRemove(): JSX.Element | undefined {
    /**
     * The click event handler.
     * @return {void}
     */
    function handleClick(): void {
      onRemove && onRemove();
    }

    return onRemove ? (
      <styled.Remove type="button" onClick={handleClick}>
        <IconSmallClose />
      </styled.Remove>
    ) : undefined;
  }

  return (
    <styled.Wrapper {...otherProps}>
      {renderLabel()}
      {renderRemove()}
    </styled.Wrapper>
  );
}

Option.defaultProps = {
  variant: OptionVariant.Default,
};

export default Option;
